import axios from 'axios'
import moment from 'moment'
import config from '../variables/config'

export const REQUEST_SENT = 'useractions/REQUEST_SENT'
export const MESSAGE_SHOWN = 'useractions/MESSAGE_SHOWN'
export const REQUEST_FAILED = 'useractions/REQUEST_FAILED'
export const REQUEST_FINISHED = 'useractions/REQUEST_FINISHED'

const initialState = {
  data: [],
  requestFailed: false,
  requestLoading: false,
  requestFinished: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SENT:
      return {
        ...state,
        requestLoading: true
      }

    case REQUEST_FAILED:
      return {
        ...state,
        requestFailed: true,
        requestLoading: false
      }

    case REQUEST_FINISHED:
      return {
        ...state,
        data: action.useractions,
        requestFinished: true,
        requestLoading: false
      }

    case MESSAGE_SHOWN:
      return {
        ...state,
        requestFailed: false,
        requestFinished: false
      }

    default:
      return state
  }
}

function getOptions(token, data, prop) {
  let options = {
    query: {
      access_token: token
    }
  }

  if (data && data.date) {
    const endDate = data.date.clone().endOf('week')
    endDate.add(1, 'days')
    const startDate = data.date.clone().startOf('week')
    startDate.set({ hour: 22, minute: 59 })

    options.params = {
      filter: {
        where: {
          and: [
            { [prop]: { lt: new Date(endDate.format()) } },
            { [prop]: { gt: new Date(startDate.format()) } }
          ]
        }
      }
    }
  }

  return options
}

export const fetchUseractions = data => {
  return async (dispatch, getState) => {
    const token = getState().admin.token
    const ops = getOptions(token, data, 'date')

    try {
      dispatch({ type: REQUEST_SENT })

      var useractions = (await axios.get(
        config.serverURL + '/UserActions',
        ops
      )).data

      if (Array.isArray(useractions)) {
        useractions.sort((a, b) => {
          var dateOne = moment(a.date)
            .startOf('day')
            .format()
          var dateTwo = moment(b.date)
            .startOf('day')
            .format()

          return moment.utc(dateOne).diff(dateTwo)
        })

        dispatch({ type: REQUEST_FINISHED, useractions: useractions })
      } else {
        dispatch({ type: REQUEST_FAILED })
      }
    } catch (error) {
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

export const createAction = data => {
  return async (dispatch, getState) => {
    const token = getState().admin.token
    try {
      await axios.post(
        config.serverURL + '/UserActions?access_token=' + token,
        data
      )

      dispatch(fetchUseractions(true))
    } catch (error) {
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

export const finishedRequest = () => {
  return dispatch => {
    dispatch({ type: MESSAGE_SHOWN })
  }
}
